import { useState, useCallback } from 'react';
import Axios from 'axios';
import { useGetRequest, usePostRequest } from "./useRequest";
import { getEnv } from '../utils/env';
import { getApiToken } from '../services/auth/msal';

const inventoryAxios = Axios.create({ baseURL: getEnv('API_BASE_URL') });

export const useWhoAmIQueryRequest = (params) =>
  useGetRequest("/User/WhoAmI", {}, null, null, true);

export const useRegionListRequest = () =>
  useGetRequest("/User/GetMyRegions", {}, null, null, true);

export const useCountryListRequest = (params = {}) =>
  useGetRequest("/User/GetMyCountries", params, null, null, true);

export const useStoreTypeListRequest = (params = {}) =>
  useGetRequest("/User/GetPosTypes", params, null, null, true);

export const useFeaturesEnabledRequest = (params = {}) =>
  useGetRequest("/User/FeaturesEnabled", params, null, null, true);

export const useModulesEnabledRequest = () =>
  useGetRequest("/User/ModulesEnabled", {}, null, null, true);

export const useUserGetPosRequest = (params = {}) =>
  usePostRequest("/User/GetPos", params, null, null, true);

export const useYearsListRequest = () =>
  useGetRequest("/Target/GetMyTargetYears", {}, null, null, true);

export const useTargetsRequest = (params = {}) =>
  usePostRequest("/Target/GetPosYearTargets", params, null, null, true);

export const usePosDayPlannedRequest = (params = {}) =>
  usePostRequest("/Target/GetPosDayPlanned", params, null, null, true);

export const usePosMonthRequest = (params = {}) =>
  usePostRequest("/Target/GetPosMonth", params, null, null, true);

export const useGetPosMonthsKpiRequest = (params = {}) =>
  usePostRequest("/Target/GetPosMonthsKPI", params, null, null, true);

export const useUpdatePosPeriodRequest = (params = {}) =>
  usePostRequest("/Target/UpdatePosPeriod", params, null, null, true);

export const usePosUsersRequest = (params = {}) =>
  usePostRequest("/Target/GetPosUsers", params, null, null, true);

export const useUpdateIsOpenPosDayRequest = (params = {}) =>
  usePostRequest("/Target/UpdateIsOpenPosDay", params, null, null, true);

export const useUpdatePlannedPosDayRequest = (params = {}) =>
  usePostRequest("/Target/UpdatePlannedPosDay", params, null, null, true);

export const useUpdatePlannedPosDaysRequest = (params = {}) =>
  usePostRequest("/Target/UpdatePlannedPosDays", params, null, null, true);

export const useUpdatePosUserRequest = (params = {}) =>
  usePostRequest("/Target/UpdatePosUser", params, null, null, true);

export const useUpdatePosUsersRequest = (params = {}) =>
  usePostRequest("/Target/UpdatePosUsers", params, null, null, true);

export const useUploadKpiFileRequest = (params = {}, fileParams) =>
{
  return usePostRequest("/Target/ImportMonthlyKPI", null, null, fileParams, true);
}

export const useUpdatePosMonthKPIRequest = (params = {}) =>
  usePostRequest("/Target/UpdatePosMonthKPI", params, null, null, true);

export const useUploadBudgetFileRequest = (params = {}, fileParams) =>
{
  return usePostRequest("/Target/ImportWeeklyBudget", null, null, fileParams, true);
}

export const useDownloadPosUserTargetExcelRequest = (params = {}) =>
  usePostRequest("/Target/DownloadPosUserTargetExcel", params, null, null, true, false, 'blob');

export const useDownloadPosYearTargetExcelRequest = (params = {}) =>
  usePostRequest("/Target/DownloadPosYearTargetExcel", params, null, null, true, false, 'blob');

export const useCopyPlannedFromPreviousYearRequest = (params = {}) =>
  usePostRequest("/Target/CopyPlannedFromPreviusYear", params, null, null, true, false, 'blob');

export const useGetInventoriesRequest = (posId, params = {}) =>
  usePostRequest(`/Inventory/${posId}/GetInventories`, params, null, null, true);

export const useGetInventoryCountRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/GetInventoryCount`, null, null, null, true);

export const useCreateInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/CreateInventory`, null, null, null, true);

export const useGetAvailableSeasonRequest = (posId) =>
  useGetRequest(`/Inventory/${posId}/GetAvailableSeason`, {}, true, false);

export const useGetAvailableGendersRequest = (posId) =>
  useGetRequest(`/Inventory/${posId}/GetAvailableGenders`, {}, true, false);

export const useGetAvailableLinesRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/GetAvailableLines`, null, null, null, true);

export const useGetAvailableMacroFamiliesRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/GetAvailableMacroFamilies`, null, null, null, true);

export const useGetAvailableMicroFamiliesRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/GetAvailableMicroFamilies`, null, null, null, true);

export const useDeleteInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/DeleteInventory`, null, null, null, true);

export const useGetSessionScannedItemsRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/GetInventorySessionItems`, null, null, null, true);

export const useGetInventoryByIdRequest = (posId) =>
  useGetRequest(`/Inventory/${posId}/GetInventoryById`, {}, true);

export const useGetInventoryItemsRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/GetInventoryItems`, null, null, null, true);

export const useGetInventoryItemResolutionReasonsRequest = (posId) =>
  useGetRequest(`/Inventory/${posId}/GetInventoryItemResolutionReasons`, {}, true);

export const useStartManagingInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/StartManagingInventory`, null, null, null, true);

export const useEndManagingInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/EndManagingInventory`, null, null, null, true);

export const useConfirmInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/ConfirmInventory`, null, null, null, true);

export const useSendForReviewInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/SendForReviewInventory`, null, null, null, true);

export const useRejectInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/RejectInventory`, null, null, null, true);

export const useEndSessionRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/EndSession`, null, null, null, true);

export const useExportInventoryRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/ExportInventory`, null, null, null, true, false, 'blob');

export const useExportInventoryDiscrepanciesRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/ExportInventoryDiscrepancies`, null, null, null, true, false, 'blob');

export const useDeleteSessionRequest = (posId) =>
  usePostRequest(`/Inventory/${posId}/DeleteSession`, null, null, null, true);

export const useOpenSessionRequest = (posId) =>
{
  const [state, setState] = useState({ loading: false, error: null, data: null });

  const openSession = useCallback(async ({ areaName, inventoryId, file }) =>
  {
    setState({ loading: true, error: null, data: null });
    try
    {
      const token = await getApiToken();
      const formData = new FormData();
      if (areaName) formData.append('AreaName', areaName);
      formData.append('InventoryId', inventoryId);
      formData.append('SessionScans', file);

      const response = await inventoryAxios.post(
        `/Inventory/${posId}/OpenSession`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setState({ loading: false, error: null, data: response.data });
      return { data: response.data };
    } catch (error)
    {
      const data = error?.response?.data;
      const errorMessage =
        (typeof data === 'string' && data.length > 0 && !data.startsWith('<') ? data : null) ||
        data?.detail ||
        data?.title ||
        data?.message ||
        data?.Message ||
        error?.response?.statusText ||
        error?.message ||
        'An error occurred';
      setState({ loading: false, error: errorMessage, data: null });
      return { error: errorMessage };
    }
  }, [posId]);

  return [state, openSession];
};

